<template>
  <div v-if="isShowLogin" class="container box_sty txt-center">
    <div class="page-login group">
      <!-- 左侧 -->
      <div class="left-img fl">
        <div class="left-text">
          <img
            class="senguo-text-logo"
            src="~@/assets/images/senguo_text_logo.svg"
            alt=""
          />
          {{ loginTitle }}
        </div>
        <img
          class="logo-img"
          src="https://static.pf.senguo.cc/static/login/img/bg_img.png?v=a7fe14fd397819d44b4fa981c3b8796c"
          alt
        />
      </div>
      <!-- 右侧 -->
      <div class="right-list">
        <p class="label">账号登录</p>
        <div class="half-hide-img">
          <div class="mask">
            <img
              v-if="loginWay == 'account-login'"
              @click="handleChangeLoginWay('scan-code-login')"
              src="~@/assets/images/code_login.png"
              alt=""
            />
            <img
              v-if="loginWay == 'scan-code-login'"
              @click="handleChangeLoginWay('account-login')"
              src="~@/assets/images/account_login.png"
              alt=""
            />
          </div>
        </div>
        <!-- tab -->
        <div class="login-type-tab login_type_tab">
          <span
            @click="loginType = 'app'"
            :class="{ active: loginType === 'app' }"
            v-show="loginWay == 'scan-code-login'"
            class="item login-by-app"
            >app扫码登录</span
          >
          <span
            @click="loginType = 'wx'"
            :class="{ active: loginType === 'wx' }"
            v-show="loginWay == 'scan-code-login'"
            class="item login-by-wx"
            >微信扫码登录</span
          >
          <span
            @click="loginType = 'pwd'"
            :class="{ active: loginType === 'pwd' }"
            v-show="loginWay == 'account-login'"
            class="item login-by-phone"
            >账号密码登录</span
          >
          <span
            @click="loginType = 'phone'"
            :class="{ active: loginType === 'phone' }"
            v-show="loginWay == 'account-login'"
            class="item login-by-phone"
            >手机号登录</span
          >
        </div>

        <!-- 扫码登录 -->
        <div class="scan-code-login" v-if="loginWay == 'scan-code-login'">
          <!-- app扫码登录 -->
          <div v-if="loginType === 'app'" class="wrap-app-login ltab_box">
            <div class="login-qrcode-box">
              <div
                :class="[
                  'wrap-login-qrcode',
                  isHover ? 'wrap-app-scan-qrcode' : '',
                ]"
                title
                v-loading="loading"
								element-loading-spinner="el-icon-loading"
                id="code1"
              >
                <img
                  v-show="false"
                  ref="logo-add-app-scan-icon"
                  src="~@/assets/images/app_scan_icon.png"
                  alt=""
                />
                <canvas class="app-scan-qrcode" ref="app-scan-canvas"></canvas>
                <img
                  class="app-scan-remind"
                  src="~@/assets/images/app_tip.png"
                  alt=""
                />
              </div>
              <div
                :class="[
                  'wrap-qrcode-outtime',
                  isHover ? 'qrcode-process-remind-translate' : '',
                ]"
                v-if="isQrCodeExpired"
              >
                <div style="margin-top: 50px">二维码已失效</div>
                <a
                  @click="getAppScanQrImage"
                  class="btn-refresh-qrcode btn_refresh_qrcode"
                  href="javascript:;"
                  >刷新</a
                >
              </div>
              <div
                :class="[
                  'qrcode-process-remind',
                  isHover ? 'qrcode-process-remind-translate' : '',
                ]"
                v-if="process.hasScaned"
              >
                <p>二维码已扫描</p>
                <p style="margin-top: 10px">请在手机上确认登录</p>
                <p class="back-to-qrcode" @click="backToQrcode">返回二维码</p>
              </div>
              <div
                :class="[
                  'qrcode-process-remind',
                  isHover ? 'qrcode-process-remind-translate' : '',
                ]"
                v-if="process.hasCanceled"
              >
                <p>登录已取消</p>
                <p style="margin-top: 10px">正在刷新二维码</p>
              </div>
            </div>
            <div class="app-login-info">
              使用
              <el-popover placement="top" trigger="hover">
                <img
                  class="app-download-link"
                  src="~@/assets/images/pfeasy_app_download.png"
                  alt=""
                />
                <img
                  class="app-logo"
                  slot="reference"
                  src="~@/assets/images/logo_easy.png"
                  alt=""
                />
              </el-popover>
              批发易、
              <el-popover placement="top" trigger="hover">
                <img
                  class="app-download-link"
                  src="~@/assets/images/ls_app_download.png"
                  alt=""
                />
                <img
                  class="app-logo"
                  slot="reference"
                  src="~@/assets/images/logo_ls.png"
                  alt=""
                />
              </el-popover>
              零售通顶部扫一扫即可登录
            </div>
          </div>
          <!-- 微信登录 -->
          <div v-show="loginType === 'wx'" class="wrap-wx-login ltab_box">
            <div class="login-qrcode-box">
              <div
                class="wrap-login-qrcode"
                title
                id="code2"
                v-loading="loading"
								element-loading-spinner="el-icon-loading"
              >
                <img
                  v-show="false"
                  ref="logo-add-wx-scan-icon"
                  src="~@/assets/images/wx_scan_icon.png"
                  alt=""
                />
                <canvas ref="canvas" v-loading="loading"></canvas>
              </div>
              <div class="wrap-qrcode-outtime" v-if="isQrCodeExpired">
                <div style="margin-top: 50px">二维码已失效</div>
                <a
                  @click="getWxQrImage"
                  class="btn-refresh-qrcode btn_refresh_qrcode"
                  href="javascript:;"
                  >刷新</a
                >
              </div>
            </div>
            <div class="wx-login-info">使用微信扫码关注公众号即可登录</div>
          </div>
        </div>

        <!-- 账号密码登录 -->
        <div class="account-login" v-if="loginWay == 'account-login'">
          <!-- 账号密码 -->
          <div v-show="loginType === 'pwd'" class="wrap-usernum-login ltab_box">
            <div class="username login-input">
              <el-input
                type="tel"
                v-model="accountId"
                placeholder="手机号"
                :maxlength="11"
                @input="phoneNumberLimit($data, 'accountId')"
              />
            </div>
            <div class="pwd login-input wrap_pw">
              <el-input
                type="password"
                v-model="password"
                placeholder="输入密码"
                :maxlength="16"
                @input="passwordLimit($data, 'password')"
                @keyup.enter.native="loginByPwd"
              />
            </div>
            <div class="login-btn">
              <button @click="loginByPwd" type="button" id="pwdLogin">
                登录
              </button>
            </div>
          </div>
          <!-- 手机号 -->
          <div
            v-show="loginType === 'phone'"
            class="wrap-usernum-login ltab_box"
          >
            <div
              class="username login-input"
              :class="{ 'ipt-error': errorMsgForm.isPhoneError }"
            >
              <el-input
                type="tel"
                v-model="phoneNumber"
                placeholder="手机号"
                :maxlength="11"
                @input="phoneNumberLimit($data, 'phoneNumber')"
                @focus="errorMsgForm.isPhoneError = false"
              />
            </div>
            <p class="error-msg" v-if="errorMsgForm.isPhoneError">
              手机号不正确
            </p>
            <div
              class="pwd login-input wrap_pw"
              :class="{ 'ipt-error': errorMsgForm.isCodeError }"
            >
              <el-input
                type="tel"
                v-model="code"
                placeholder="输入短信验证码"
                :maxlength="4"
                @input="verifyCodeLimit($data, 'code')"
                @focus="errorMsgForm.isCodeError = false"
                @keyup.enter.native="loginByPhone"
              />
              <span
                ref="getCode"
                @click="getLoginMessage"
                class="get-code"
                :class="{ get_code: lock }"
                data-action="login"
                >{{ phoneMsg }}</span
              >
            </div>
            <p class="error-msg" v-if="errorMsgForm.isCodeError">
              验证码不正确
            </p>
            <div class="login-btn">
              <button @click="loginByPhone" type="button" id="phoneLogin">
                登录
              </button>
            </div>
          </div>
        </div>

        <div class="login-privacy">
          “登录”即表示同意
          <a
            class="login-link"
            href="https://i.senguo.cc/bbs/privacy/792812a51880032b"
            target="_blank"
            >《用户协议》</a
          >和
          <a
            class="login-link"
            href="https://i.senguo.cc/bbs/privacy/5eb92b2b36fcc540"
            target="_blank"
            >《隐私协议》</a
          >
        </div>
      </div>
    </div>
    <ypsdk ref="ypsdk" />
    <tips-dialog ref="passwordTipsDialog" title="系统提示" btnContent="确认">
      <div slot="content">
        <p>您的密码过于简单，请更换其他方式登录</p>
        <p>并在登录后前往个人中心修改密码</p>
      </div>
    </tips-dialog>
  </div>
</template>

<script>
import tipsDialog from "./components/tips-dialog.vue";
import BTime from "best-calendar";
import qrcode from "qrcode";
import ypsdk from "@/components/ypsdk/ypsdk";
import encryption from "@/assets/js/encryption.js";
import { inputLimit, isPasswordEffective } from "@/utils";
import api from "@/api";
import { isCashierEnv } from "@/utils";
const fetch = api.fetch;
const bindWxUrl = "/sellerRegister";
const bindPhoneUrl = "/sellerRegister?type=bind_phone";

export default {
  data() {
    return {
      loginTitle: isCashierEnv() ? "收银台登录页面" : "商户后台登录页面",
      loginWay: "scan-code-login", // 扫码登录还是账号登录
      loginType: "app", // 具体哪种登录方式
      oa: "oa_pifa",
      scan_id: "", // app扫码登录时的scan_id
      accountId: "",
      password: "",
      phoneNumber: "",
      code: "",
      phoneMsg: "获取验证码",
      lock: false,
      waitTimer: null, // 计时timer
      pollingTimer: null, // 轮询timer
      isQrCodeExpired: false, // 二维码是否超时
      process: {
        // 二维码过程状态
        hasScaned: false, // 已被扫
        hasCanceled: false, // 已取消
      },
      errorMsgForm: {
        isPhoneError: false,
        isCodeError: false,
      },
      isShowLogin: true,
      isHover: false,
      loading: false,
    };
  },
  watch: {
    loginType(newType) {
      this.clearTimer();
      if (newType === "wx") {
        this.getWxQrImage();
      } else if (newType === "app") {
        this.getAppScanQrImage();
      }
    },
  },
  created() {
    this.phoneReg = /^1[3456789]\d{9}$/;
    this.firstPicValid = true;
  },
  mounted() {
    this.initPage();
  },
  beforeDestroy() {
    this.clearTimer();
  },
  beforeRouteEnter(to, from, next) {
    fetch
      .get({
        url: "/user",
      })
      .then((data) => {
        if (data.success) {
          if (!data.user.phone) {
            next((vm) => {
              vm.$message.error("请先绑定手机号");
              vm.$router.push(bindPhoneUrl);
            });
          } else if (
            !data.user.wx_unionid ||
            data.user.wx_unionid === "(NULL)"
          ) {
            next((vm) => {
              vm.$message.error("请先绑定微信");
              // 绑定微信 (携带参数)
              if (vm.$route.query.oa === "new_ls") {
                vm.$router.push({
                  path: bindWxUrl,
                  query: {
                    oa: "new_ls",
                  },
                });
              } else {
                vm.$router.push(bindWxUrl);
              }
            });
          } else {
            next((vm) => {
              vm.isShowLogin = false;
              vm.goToUrl();
            });
          }
        } else {
          next();
        }
      })
      .catch(() => next());
  },
  methods: {
    phoneNumberLimit: inputLimit(/^([1]{1}\d{0,10})$/),
    passwordLimit: inputLimit(/^\w*$/),
    verifyCodeLimit: inputLimit(/^\d{0,4}$/),

    /**
     * 页面初始化
     * 公众号迁移对应的登录、通知、支付、扫码公众号调整   https://tower.im/teams/175903/todos/50200/
     * 微信登录：处理 公众号 oa_pifa-批发易(默认) oa_lingshou-零售通
     */
    initPage() {
      if (this.$route.query.oa === "new_ls") {
        this.oa = "oa_lingshou";
      } else {
        this.oa = "oa_pifa";
      }
      // app扫码登录
      this.getAppScanQrImage();
    },

    // 切换支付方式
    handleChangeLoginWay(type) {
      this.loading = false;
      this.loginWay = type;
      if (type === "scan-code-login") {
        this.loginType = "app";
      } else {
        this.loginType = "pwd";
      }
    },

    backToQrcode() {
      this.clearTimer();
      this.getAppScanQrImage();
    },

    // 二维码过期计时
    startTimer() {
      this.isQrCodeExpired = false;
      this.process = {
        hasScaned: false,
        hasCanceled: false,
      };
      this.waitTimer = setTimeout(() => {
        this.isQrCodeExpired = true;
        this.process = {
          hasScaned: false,
          hasCanceled: false,
        };
        this.pollingTimer && clearTimeout(this.pollingTimer);
      }, 1000 * 60 * 10);
    },

    // 清除计时
    clearTimer() {
      this.pollingTimer && clearTimeout(this.pollingTimer);
      this.waitTimer && clearTimeout(this.waitTimer);
    },

    // 微信登录：获取二维码
    getWxQrImage() {
      this.loading = true;
      this.$fetch
        .post({
          url: "/login?method=get_wx_ticket",
          params: {
            action: "login",
            oa: this.oa,
          },
        })
        .then((res) => {
          this.scene_id = res.scene_id;
          const canvas = this.$refs.canvas;
          this.loading = false;
          if (canvas) {
            qrcode.toCanvas(canvas, res.ticket_url, (e) => {
              if (e) {
                this.isQrCodeExpired = true;
                this.openMessage(0, "生成二维码失败");
              } else {
                const iconRef = this.$refs["logo-add-wx-scan-icon"];
                canvas.getContext("2d").drawImage(iconRef, 64, 64, 36, 36);
                this.startTimer();
                this.getWxLoginResult();
              }
            });
          }
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.isQrCodeExpired = true;
          this.openMessage(0, e.error_text || "获取微信扫码登录二维码失败");
        });
    },

    // 微信登录：轮询结果
    getWxLoginResult() {
      this.$fetch
        .post({
          url: "/login?method=login_by_wx_ticket",
          params: {
            scene_id: this.scene_id,
            oa: this.oa,
          },
        })
        .then((res) => {
          if (!res.done && !this.isQrCodeExpired) {
            this.pollingTimer = setTimeout(() => {
              this.getWxLoginResult();
            }, 2000);
          } else {
            if (res.phone_bind) {
              // 绑定了手机
              this.openMessage(1, "登录成功");
              this.goToUrl();
            } else {
              // 未绑定手机
              this.$router.push({
                path: "/sellerRegister",
                query: {
                  type: "bind_phone",
                },
              });
            }
          }
        })
        .catch((e) => {
          // 继续轮询
          // this.getWxLoginResult()
          this.openMessage(0, e.error_text || "检测微信绑定错误");
        });
    },

    // app扫码登录：获取二维码
    getAppScanQrImage() {
			this.isHover = false;
      this.loading = true;
      this.$fetch
        .get({
          url: "/login-qrcode/get",
          params: {
            platform: 2, // 代表中台发起的
          },
        })
        .then((data) => {
          this.isQrCodeExpired = false;
          this.scan_id = data.scan_id;
          const canvas = this.$refs["app-scan-canvas"];
          this.loading = false;
          if (canvas) {
            qrcode.toCanvas(canvas, data.link, (e) => {
              if (e) {
                this.isQrCodeExpired = true;
                this.openMessage(0, "生成二维码失败");
              } else {
                const iconRef = this.$refs["logo-add-app-scan-icon"];
                canvas.getContext("2d").drawImage(iconRef, 80, 80, 36, 36);
                this.startTimer();
                this.getAppScanLoginResult();
                this.isHover = true;
              }
            });
          }
        })
        .catch((e) => {
          this.loading = false;
          this.isQrCodeExpired = true;
          this.openMessage(0, e.error_text || "获取二维码失败");
        });
    },

    // app扫码登录：轮询结果
    getAppScanLoginResult() {
      this.$fetch
        .get({
          url: "/login-qrcode-status/get",
          params: {
            scan_id: this.scan_id,
          },
        })
        .then((res) => {
          if (res.status == 3) {
            // 登录成功：跳转页面
            this.openMessage(1, "登录成功");
            this.goToUrl();
          } else if (res.status == 1) {
            // 等待中：继续轮询
            this.pollingTimer = setTimeout(() => {
              this.getAppScanLoginResult();
            }, 2000);
          } else if (res.status == 4) {
            // 二维码已被扫：继续轮询
            this.process.hasCanceled = false;
            this.process.hasScaned = true;
            this.pollingTimer = setTimeout(() => {
              this.getAppScanLoginResult();
            }, 2000);
          } else if (res.status == 5) {
            // 已取消登录：重新生成二维码
            this.process.hasScaned = false;
            this.process.hasCanceled = true;
            setTimeout(() => {
              this.clearTimer();
              this.getAppScanQrImage();
            }, 1000);
          } else {
            // 无效
            this.openMessage(0, "二维码失效");
          }
        })
        .catch((e) => {
          this.openMessage(0, e.error_text || "app扫码登录轮询失败");
        });
    },

    getLoginMessage() {
      if (!this.phoneReg.test(this.phoneNumber)) {
        return (this.errorMsgForm.isPhoneError = true);
      }
      this.validCode();
    },

    validCode(flag) {
      if (this.lock) return;
      this.lock = true;
      const params = {
        action: "login",
        phone: this.phoneNumber,
      };
      if (flag) {
        // 图片验证
        params.captcha_token = this.token;
        params.captcha_authenticate = this.authenticate;
      }
      this.countDown = new BTime.CountDown(60000, 0);
      this.countDown.on("timing", (time) => {
        this.phoneMsg = `(${time.second}s)`;
      });
      this.countDown.on("timend", () => {
        this.lock = false;
        this.phoneMsg = "获取验证码";
      });
      this.$fetch
        .post({
          url: "/captcha",
          params,
        })
        .then(
          (data) => {
            if (data.need_captcha && this.firstPicValid) {
              // 图形验证
              this.firstPicValid = false;
              this.ypValid();
            } else {
              // 直接获取验证码
              this.firstPicValid = true;
              console.log("验证码：", data);
            }
          },
          (e) => {
            if (
              !e.success &&
              e.error_text.includes("图形验证") &&
              this.firstPicValid
            ) {
              this.firstPicValid = false;
              return this.ypValid();
            }
            this.firstPicValid = true;
            this.openMessage(0, e.error_text || "获取验证码失败");
            this.countDown && this.countDown.stop(true);
          }
        );
    },

    ypValid() {
      this.countDown && this.countDown.stop(true);
      this.$nextTick(() => {
        this.$refs.ypsdk.ready().then(
          ({ token, authenticate }) => {
            this.token = token;
            this.authenticate = authenticate;
            this.validCode(true);
          },
          () => {}
        );
      });
    },

    // 验证码登陆
    loginByPhone() {
      if (this.phoneLock) return;
      if (!this.phoneReg.test(this.phoneNumber)) {
        return (this.errorMsgForm.isPhoneError = true);
      }
      if (this.code === "") {
        return (this.errorMsgForm.isCodeError = true);
      }
      this.phoneLock = true;
      this.$fetch
        .post({
          url: "/login?method=login_by_phone_code",
          params: {
            phone: this.phoneNumber,
            code: this.code,
          },
        })
        .then(
          (data) => {
            if (data.success) {
              if (data.bind_wx) {
                this.openMessage(1, "登录成功");
                this.goToUrl();
              } else {
                // 根据this.$route.query.oa === 'new_ls' 来判断是否是新零售用户
                if (this.$route.query.oa === "new_ls") {
                  this.$router.push({
                    path: "/sellerRegister",
                    query: {
                      type: "bind_wx",
                      oa: "new_ls",
                    },
                  });
                } else {
                  this.$router.push({
                    path: "/sellerRegister",
                    query: {
                      type: "bind_wx",
                    },
                  });
                }
              }
            }
          },
          (e) => {
            if (e.error_text.includes("验证码")) {
              this.errorMsgForm.isCodeError = true;
            } else {
              this.openMessage(0, e.error_text || "登录失败");
            }
            this.phoneLock = false;
          }
        );
    },

    // 密码登录
    loginByPwd() {
      if (this.pwdLock) return;
      if (!(this.accountId && this.password)) {
        return this.openMessage(0, "用户名或密码不能为空");
      }
      if (!this.phoneReg.test(this.accountId)) {
        return this.openMessage(0, "请先输入正确的手机号");
      }
      if (!isPasswordEffective(this.password)) {
        this.$refs["passwordTipsDialog"].open();
        return false;
      }
      this.pwdLock = true;
      this.$fetch
        .post({
          url: "/login?method=login_by_phone_password",
          params: {
            phone: this.accountId,
            password: encryption(this.password),
          },
        })
        .then(
          (data) => {
            if (data.success) {
              this.openMessage(1, "登录成功");
              this.goToUrl();
            } else {
              this.openMessage(0, "用户名或密码错误");
            }
          },
          (e) => {
            if (e.error_text.includes("密码错误")) {
              this.openMessage(0, "用户名或密码错误");
            } else {
              this.openMessage(0, e.error_text || "登录失败");
            }
            this.pwdLock = false;
          }
        );
    },

    iptChange(val, prop) {
      let reg = /[^\d]/g;
      if (prop === "password") {
        reg = /[^\d\w]/g;
      }
      this[prop] = val.replace(reg, "");
    },
  },

  components: {
    ypsdk,
    tipsDialog,
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
  z-index: 2;

  .page-login {
    margin: 130px auto 0 auto;
    display: inline-block;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    background: linear-gradient(to bottom, #c6efe1 0, #c8e6ee 100%);
    position: relative;
    width: 680px;

    .logo-img {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 220px;
    }

    .logo-txt {
      display: block;
      margin: 0 auto;
      width: 120px;
      height: 30px;
      line-height: 30px;
      margin-top: 20px;
      font-size: 18px;
      border: 1px #000 solid;
      user-select: none;
      background: transparent;
    }

    .left-img {
      height: 350px;
      width: 250px;
      position: relative;
      overflow: hidden;
    }

    .left-text {
      width: 270px;
      line-height: 1.5;
      padding: 20px 0 0 20px;
      font-size: 26px;
      color: #333;
      letter-spacing: 0;
      text-align: left;

      .senguo-text-logo {
        width: 102px;
        height: 30px;
        display: block;
      }
    }

    .right-list {
      position: relative;
      padding: 38px 20px;
      width: 340px;
      border-radius: 0 4px 4px 0;
      position: absolute;
      top: -15px;
      right: 20px;
      background-color: #fff;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);

      .half-hide-img {
        position: absolute;
        right: 0;
        top: 0;
        width: 58px;
        height: 58px;
        background: #eee;
        overflow: hidden;
        user-select: none;

        .mask {
          text-align: right;
          padding-top: 5px;
          padding-right: 5px;

          img {
            width: 22px;
            height: 22px;
            cursor: pointer;
          }

          &:after {
            position: absolute;
            left: 0;
            bottom: 0;
            content: "";
            display: block;
            width: 0;
            height: 0;
            border: 48px solid #fff;
            border-top-color: transparent;
            border-left-color: transparent;
            border-bottom-color: transparent;
            transform: rotate(-45deg) translateX(-74px);
            box-shadow: 0 0 5px #ccc;
          }
        }
      }

      .label {
        text-align: center;
        font-size: 24px;
      }

      .login-type-tab {
        font-size: 14px;
        text-align: center;
        margin-top: 12px;
        height: 32px;
        line-height: 32px;

        .item {
          display: inline-block;
          width: 88px;
          margin: 0 4px;
          position: relative;
          color: #333;
          border-bottom: 2px solid transparent;
          transition: color 0.2s ease 0s;
          font-size: 14px;
          user-select: none;
          cursor: pointer;
        }

        .active {
          border-bottom: 2px solid #58d0a6;
        }
      }

      .wrap-wx-login,
      .wrap-app-login {
        margin-top: 10px;
        text-align: center;

        .login-qrcode-box {
          position: relative;
          width: 180px;
          height: 180px;
          margin: 0 auto;

          .wrap-login-qrcode {
            position: relative;
            width: 180px;
            height: 180px;
            background-color: #ecf1ef;

            canvas {
              max-width: 100%;
              max-height: 100%;
              min-width: 100%;
              min-height: 100%;
              transition: transform 0.3s ease;
            }

            .app-scan-remind {
              position: absolute;
              right: -45px;
              top: 0;
              width: 90px;
              opacity: 0;
              transition: opacity 0.3s ease;
            }
          }

          .wrap-app-scan-qrcode {
            .app-scan-remind {
              opacity: 1;
            }
            .app-scan-qrcode {
              transform: translate3d(-45px, 0, 0);
            }
          }
          .qrcode-process-remind-translate {
            transform: translate3d(-45px, 0, 0);
          }
        }
      }

      .wrap-qrcode-outtime {
        position: absolute;
        z-index: 5;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        font-size: 14px;
        text-align: center;
        color: #fff;
      }

      .qrcode-process-remind {
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        font-size: 14px;
        text-align: center;
        color: #fff;

        .back-to-qrcode {
          margin-top: 20px;
          cursor: pointer;
          font-weight: bold;
        }
      }

      .btn-refresh-qrcode {
        margin-top: 6px;
        display: inline-block;
        color: #fff;
        line-height: 34px;
        width: 64px;
        background: #58d0a6;
        border-radius: 4px;
        font-size: 16px;
      }

      .wrap-usernum-login {
        margin-top: 30px;
      }
    }

    .app-login-info {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666;
      margin: 30px 0 8px;
      font-size: 12px;

      .app-logo {
        width: 20px;
        height: 20px;
        border-radius: 5px;
        margin: 0 5px;
        filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.3));
      }
    }

    .wx-login-info {
      text-align: center;
      color: #666;
      margin: 30px 0 8px;
      font-size: 12px;
    }

    .wrap-usernum-login {
      margin-top: 30px;

      .login-input {
        height: 50px;
        width: 300px;
        margin-top: 14px;
        position: relative;

        &.ipt-error {
          input,
          /deep/ .el-input__inner {
            border: 1px solid #e51c23;
          }
        }

        input,
        /deep/ .el-input__inner {
          height: 50px;
          width: 300px;
          padding: 0 !important;
          font-size: 14px;
          text-indent: 10px;
          border-radius: 2px;

          &::placeholder {
            color: #333;
          }

          &:focus {
            border: 1px solid #58d0a6;
            box-shadow: 0 0 6px #58d0a6;
          }
        }
      }

      .get-code {
        position: absolute;
        right: 1px;
        top: 1px;
        background-color: #47b8a0;
        color: #fff;
        text-align: center;
        height: 48px;
        line-height: 48px;
        width: 100px;
        user-select: none;
        cursor: pointer;

        &.get_code {
          background-color: #ddd;
          color: #999;
          border-color: #ddd;
        }
      }
    }

    .login-btn {
      width: 300px;
      text-align: center;
      margin: 30px 0 14px 0;
      cursor: pointer;

      button {
        border: none;
        width: 100%;
        height: 50px;
        font-size: 18px;
        line-height: 50px;
        background-color: #47b8a0;
        color: #fff;
        border-radius: 40px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
      }
    }

    .login-privacy {
      text-align: center;
      color: #999;
      font-size: 12px;

      .login-link {
        color: #309cff;
        font-size: 12px;
      }
    }
  }
}

input {
  border: 1px solid #eee;
  outline: 0;
  -webkit-appearance: none;
}

button {
  outline: none;
  cursor: pointer;
}

a {
  text-decoration: none;
}

.fl {
  float: left;
}

.box_sty {
  width: 100%;
  min-width: 320px;
  margin: 0 auto;
  max-width: 1000px !important;
}

.txt-center {
  text-align: center;
}

.error-msg {
  padding: 8px 10px;
  font-size: 12px;
  color: #e51c23;
  text-align: left;
}
</style>

<style lang="scss">
.app-download-link {
  width: 160px;
  height: 160px;
}
.el-icon-loading {
	font-size: 24px;
	color: #333 !important;
}
</style>